import logo from "@/assets/work-and-you-logo-transparent.png";

const SiteFooter = () => (
  <footer className="bg-muted text-navy">
    <div className="brand-separator" />
    <div className="container flex flex-col items-center justify-between gap-6 px-6 py-10 text-center md:flex-row md:text-left">
      <img src={logo} alt="Work&You, cabinet de recrutement" className="h-16 w-auto" width="1584" height="672" loading="lazy" />
      <p className="font-semibold">Provoquons <span className="text-primary">LA</span> Rencontre Professionnelle</p>
      <p className="text-sm text-muted-foreground">© 2026 Work&You</p>
    </div>
  </footer>
);

export default SiteFooter;